import React from 'react'
import { Box, Typography } from '@mui/material'

const MaintenancePage = ({
  title,
  description
}: {
  title: string
  description: string
}) => (
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      p: 3
    }}
  >
    <Typography variant='h3' gutterBottom>
      {title || 'Site Under Maintenance'}
    </Typography>
    <Typography variant='body1'>
      {description || 'We’ll be back soon.'}
    </Typography>
  </Box>
)

export default MaintenancePage
